import Vue from "vue";
import LibDropdown from "./LibDropdown.vue";
import LibFaq from "./LibFaq";
import LibSelect from "./LibSelect.vue";
import LibRadioSelect from "./LibRadioSelect.vue";
import LibStripeCard from "./LibStripeCard.vue";
import LibTabs from "./LibTabs";
import LibAccordion from "./LibAccordion";
import LibPricing from "./LibPricing";
import { VueTelInput } from "./vue-tel-input";
Vue.component("lib-accordion", LibAccordion);
Vue.component("lib-dropdown", LibDropdown);
Vue.component("lib-faq", LibFaq);
Vue.component("lib-pricing", LibPricing);
Vue.component("lib-select", LibSelect);
Vue.component("lib-radio-select", LibRadioSelect);
Vue.component("lib-stripe-card", LibStripeCard);
Vue.component("lib-tabs", LibTabs);
Vue.component("lib-tel-input", VueTelInput);
export { Vue, LibAccordion, LibDropdown, LibTabs };
//# sourceMappingURL=index.js.map